// extracted by mini-css-extract-plugin
module.exports = {"Container":"EditProfileCard_Container__3jJwT","Img":"EditProfileCard_Img__piw1L","ImgPlaceholder":"EditProfileCard_ImgPlaceholder__1n9mg"};